import { render, staticRenderFns } from "./ReturnRecord.vue?vue&type=template&id=9a24bec2&scoped=true"
import script from "./ReturnRecord.vue?vue&type=script&lang=js"
export * from "./ReturnRecord.vue?vue&type=script&lang=js"
import style0 from "./ReturnRecord.vue?vue&type=style&index=0&id=9a24bec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a24bec2",
  null
  
)

export default component.exports